import { useEffect, useState } from "react";

import AutoCompleteDropdown from "../../../ui library/components/dropdowns/AutoCompleteDropdown";
import CustomListBox from "../../Documents/UploadDocuments/components/CustomListBox";
import { STRINGS } from "../utils/Strings";
import { tableAutocompleteProps } from "../utils/styles";

export default function ReferralFrom({
  caseId,
  initValue,
  repository,
  onChange,
  isTableView = false,
}) {
  const [selectedValue, setSelectedValue] = useState(initValue ?? null);
  const [data, setData] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [searchText, setSearchText] = useState("");

  const parseData = (items) =>
    items.map((item) => ({
      id: item?.provider?.id ?? item?.provider?.pk ?? item?.key,
      key: item?.provider?.id ?? item?.provider?.pk ?? item?.key,
      label: item?.provider?.name ?? item?.value,
      providerTypes: item?.provider?.providerTypes ?? [],
    }));

  const fetchData = async (
    caseId,
    search = "",
    limit = STRINGS.DEFAULT_LIMIT,
    offset = STRINGS.DEFAULT_OFFSET
  ) => {
    const params = { case: caseId, limit: limit, offset: offset };
    if (search) {
      params.search = search;
    }
console.log(repository);
    const response = await repository.getRelatedProviders(caseId, params);
    const mapped = parseData(response);

    if (offset === 0) {
      setData(mapped);
    } else {
      setData((prev) => [...prev, ...mapped]);
    }

    const next = await repository.getNextPage();
    setNextPage(next);
    setShowMore(!!next);
  };

  const fetchNextPage = async () => {
    if (!nextPage) {
      return;
    }
    const url = new URL(nextPage);
    const newLimit = parseInt(url.searchParams.get("limit"));
    const newOffset = parseInt(url.searchParams.get("offset"));
    await fetchData(caseId, searchText, newLimit, newOffset);
  };

  const reset = async () => {
    setSelectedValue(null);
    setSearchText("");
    await fetchData(caseId, "", STRINGS.DEFAULT_LIMIT, STRINGS.DEFAULT_OFFSET);
    onChange("referralFrom", null);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData(caseId, searchText, STRINGS.DEFAULT_LIMIT, STRINGS.DEFAULT_OFFSET);
    }, 750);
    return () => clearTimeout(timeout);
  }, [searchText]);

  useEffect(() => {
    fetchData(caseId, "", STRINGS.DEFAULT_LIMIT, STRINGS.DEFAULT_OFFSET);
  }, []);

  const handleOnChange = async (value) => {
    if (!value) {
      await reset();
    } else {
      setSelectedValue(value);
      onChange("referralFrom", value);
    }
  };

  return (
    <AutoCompleteDropdown
      freeSolo={true}
      label={isTableView ? "" : "Referral From Provider*"}
      textFieldSx={isTableView ? tableAutocompleteProps : {}}
      data={data}
      initValue={selectedValue}
      getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
      onValueChange={(_, value) => handleOnChange(value)}
      onInputChange={(_, newInputValue, reason) => {
        if (reason === "input") {
          setSearchText(newInputValue);
        } else if (reason === "clear") {
          reset();
        }
      }}
      ListboxComponent={CustomListBox}
      ListboxProps={{
        showMore,
        setShowMore: fetchNextPage,
      }}
    />
  );
}
